import React from 'react';
import PropTypes from 'prop-types';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage } from 'react-intl';
import utils from '@/shared/utils/adminpulse';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import messages from '../jobMessages';
import FormattedDateShort from '@/shared/components/FormattedDateShort';

const JobDetailChangeTaskField = ({ job, intl }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);
  if (!parameters) return null;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-2 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Field} />
                  </b>
                </label>
              </div>
              <div className="col-md-10 col-sm-6">
                <FormattedListValue list="BatchTaskField" id={parameters.field} fallback="" />
              </div>
            </div>
            {parameters.field === 0 && (
              <div className="row">
                <div className="col-md-2 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.Deadline} />
                    </b>
                  </label>
                </div>
                <div className="col-md-10 col-sm-6">
                  {parameters.deadline ? <FormattedDateShort value={parameters.deadline} /> : '/'}
                </div>
              </div>
            )}
            {parameters.field === 1 && (
              <div className="row">
                <div className="col-md-2 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.Status} />
                    </b>
                  </label>
                </div>
                <div className="col-md-10 col-sm-6">
                  {parameters.inapplicable ? (
                    <FormattedListValue list="extendedtaskstatus" id={4} fallback="" />
                  ) : parameters.rejected ? (
                    <FormattedListValue list="extendedtaskstatus" id={6} fallback="" />
                  ) : (
                    <FormattedListValue list="TaskStatus" id={parameters.status} fallback="" />
                  )}
                </div>
              </div>
            )}
            {parameters.field === 2 && (
              <div className="row">
                <div className="col-md-2 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.ReferenceYear} />
                    </b>
                  </label>
                </div>
                <div className="col-md-10 col-sm-6">
                  {parameters.referenceYear < 0 && (
                    <FormattedMessage {...messages.RecalculateReferenceYear} />
                  )}
                  {parameters.referenceYear === 0 && (
                    <FormattedMessage {...messages.ClearReferenceYear} />
                  )}
                  {parameters.referenceYear > 0 ? parameters.referenceYear : null}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailChangeTaskField.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailChangeTaskField);
